import styles from '../styles/bim.module.scss';
import buttons_styles from '../styles/buttons.module.scss';
import { useContext, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../Context';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
// import { projectSetup } from '../project-setup';

//media
import UpArrowIcon from '../media/img/Menu/up-arrow.svg';
import DownArrowIcon from '../media/img/Menu/down-arrow.svg';
import PlusIcon from '../media/img/Menu/plus.svg';
import MinusIcon from '../media/img/Menu/minus.svg';
import { ReactComponent as IconPlus } from '../media/img/icon-plus.svg';
import { ReactComponent as IconMinus } from '../media/img/icon-minus.svg';
import { ReactComponent as IconChevron } from '../media/img/icon-chevron.svg';
import { ReactComponent as IconCompass } from '../components/ApartmentView/assets/icons/icon-north.svg';

//components
import Loading from './Loading';
import ToolTip from './ToolTip';
import TierSvgLayer from './layers/TierSvgLayer';
import ComponentCloseButton from './ComponentCloseButton';

//utils
import { getRotateToNorthAngleDeg } from '../components/ApartmentView/utils/geometryUtils';

import { AVAILABILITY_STATUS } from '../constants/availabilityStatus';
import {
	appendSvgHeightWidth,
	appendSvgStyle,
} from './ApartmentView/utils/svgUtils';
import ToggleButtonsGroup from './_shared/ToggleButtonsGroup';
const { AVAILABLE, SOLD } = AVAILABILITY_STATUS;

function TiersView() {
	const {
		dataUrl,
		setActiveBuilding,
		tiersViewRef,
		setActiveApartmentHandle,
		activeApartment,
		projectStyle,
		isDesktop,
		isMobile,
		projectData,
		loading,
		buildingsData,
		activeBuilding,
		tiersData,
		displayableApartmentsData: apartmentsData,
		filteredApartmentData,
		activeTier,
		setActiveTier,
		projectSetup,
		updateUrlHash,
		applyFiltersHandler,
	} = useContext(Context);
	const [componentLoading, setComponentLoading] = useState(false);
	const [viewType, setViewType] = useState(0);
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [tooltipContent, setTooltipContent] = useState(false);
	const [initialActiveEdifice, setInitialEdifice] = useState(0);

	const lastClickedMobileElementRef = useRef(null);

	const [compassAzimuth, setCompassAzimuth] = useState(0);

	const [tiersLayers, setTiersLayers] = useState(null);
	const [activeTierLayerSvg, setActiveTierLayerSvg] = useState(null);
	const [activeTierIndex, setActiveTierIndex] = useState(0);

	const [roomFilter, setRoomFilter] = useState([]);

	const [visibleBuildingsTiers, setVisibleBuildingsTiers] = useState([]);

	const Viewer = useRef(null);
	const isInitialMount = useRef(true);
	const listenersRef = useRef([]);
	const tiersScrollContainerRef = useRef(null);
	const scrollIntervalRef = useRef(null);

	const areSoldAccessible =
		projectSetup?.website?.are_sold_apartments_accessible ?? false;

	const { t } = useTranslation();

	const MAX_VISIBLE_TIERS = 9;
	const TIER_BUTTON_HEIGHT = '3rem'; // height of one tier button

	const handleScrollTiers = (direction) => {
		if (!tiersScrollContainerRef.current) return;
		const container = tiersScrollContainerRef.current;

		// Parse 3rem to pixels based on root font size
		const remInPixels = parseFloat(
			getComputedStyle(document.documentElement).fontSize
		);
		const scrollAmount = 3 * remInPixels; // 3rem in pixels

		const currentScroll = container.scrollTop;
		const targetScroll =
			direction === 'up'
				? currentScroll - scrollAmount
				: currentScroll + scrollAmount;

		container.scrollTo({
			top: targetScroll,
			behavior: 'smooth',
		});
	};

	const handleChevronMouseDown = (direction) => {
		handleScrollTiers(direction);
		scrollIntervalRef.current = setInterval(() => {
			handleScrollTiers(direction);
		}, 150);
	};

	const handleChevronMouseUp = () => {
		if (scrollIntervalRef.current) {
			clearInterval(scrollIntervalRef.current);
			scrollIntervalRef.current = null;
		}
	};

	const scrollTierIntoView = (tierIndex) => {
		if (!tiersScrollContainerRef.current) return;

		const container = tiersScrollContainerRef.current;
		const toggleGroup = container.querySelector('[class*="bim_button_group"]');
		if (!toggleGroup) return;

		const buttons = toggleGroup.querySelectorAll('button');
		if (!buttons || buttons.length === 0) return;

		// Find the button from the end (since they're reversed)
		const reversedIndex = buttons.length - 1 - tierIndex;
		const targetButton = buttons[reversedIndex];

		if (targetButton) {
			const containerHeight = container.clientHeight;
			const buttonTop = targetButton.offsetTop;
			const buttonHeight = targetButton.offsetHeight;

			// Calculate scroll position to center the button
			const scrollPosition = buttonTop - containerHeight / 2 + buttonHeight / 2;

			container.scrollTo({
				top: scrollPosition,
				behavior: 'smooth',
			});
		}
	};

	// function toggleRoomFilter(roomsNum) {
	//   const elements = document.querySelectorAll(`[data-rooms="${roomsNum}"]`);
	//   elements.forEach((element) => {
	//     element.classList.toggle('active_filter');
	//   });
	// }

	function getApartmentTypeLabel(apartment) {
		if (!apartment?.type) return '';
		const firstLetter = apartment.type[0].toUpperCase();
		if (firstLetter === 'M') return t('apartment');
		if (firstLetter === 'U') return t('unit');
		if (firstLetter === 'B') return t('premises');
		return '';
	}

	function setLayerListener() {
		listenersRef.current.forEach(({ element, eventType, handler }) => {
			element.removeEventListener(eventType, handler);
		});
		const newRoomsFilterValues = [];
		const apartmentsPaths = document.querySelectorAll('.tier path.rm');
		// const newApartmentsPaths = document.querySelectorAll('.apartments path.interior');
		// const apartmentsGroup = document.querySelectorAll('.apartments');
		const apartmentGroups = document.querySelectorAll('.apartments > g');

		let currentTiers = activeBuilding
			? tiersData.filter((tier) => tier.edifice === activeBuilding)
			: tiersData;
		let allApartmentsFromData = apartmentsData;
		let visibleFilteredApartments = filteredApartmentData;

		// if (apartmentsPaths && apartmentsPaths.length > 1) {
		if (apartmentGroups && apartmentGroups.length > 0) {
			apartmentGroups.forEach((apartmentGroup) => {
				const apartmentUuidFromPath = apartmentGroup.id;
				const apartmentPath = apartmentGroup.querySelector('path.interior');
				// const apartmentIdFromPath = apartmentPath.getAttribute('data-ap');
				if (!apartmentPath) return;

				const apartmentData = allApartmentsFromData.find(
					(apt) => apt.uuid === apartmentUuidFromPath
					// (apt) => apt.id_original === apartmentIdFromPath
				);
				const isVisibleAfterFilter = visibleFilteredApartments.some(
					(apt) => apt.uuid === apartmentUuidFromPath
					// (apt) => apt.id_original === apartmentIdFromPath
				);
				const apartmentIdFromPath = allApartmentsFromData.find(
					(apt) => apt.uuid === apartmentUuidFromPath
				)?.id_original;

				// const apartment = apartmentsData.find(apartment => apartmentData.id_original === apartmentIdFromPath);

				let apartmentTooltipContent = {};
				let filteredApartmentTooltipContent = {};
				let isInaccessibleTooltipContent = {
					title: t('inaccessible'), //TODO: when SimilarApartments feature is implemented, inform user about found similar apartments
				};

				if (apartmentData) {
					const apartmentLabel = getApartmentTypeLabel(apartmentData);
					const title = `${apartmentLabel} - ${
						apartmentData.id_original ?? apartmentData.id_original
					}`;
					const surface = `${t('surface')}: ${apartmentData.area_original}`;
					const rooms = `${t('rooms')}: ${apartmentData.rooms}`;
					const availability = apartmentData.availability ?? AVAILABLE;
					const tierForApartmentData = currentTiers.find(
						(t) => t.ref_tier === apartmentData.ref_tier
					);
					const tierNameForApartment =
						tierForApartmentData?.name_original ??
						(apartmentData.ref_tier || '');

					const tiersForApartmentData =
						currentTiers.filter((tier) =>
							apartmentData.tiers.map((t) => t.ref_tier).includes(tier.ref_tier)
						) || [];
					const tierNamesForApartment = tiersForApartmentData.map(
						(tier) => tier.name_original || tier.ref_tier
					);

					const tierText =
						tierNamesForApartment.length === 1
							? `${t('tier')}: ${tierNameForApartment}`
							: `${t('tiers')}: ${tierNamesForApartment.join(', ')}`;
					const btnText = projectSetup.website.are_sold_apartments_accessible
						? t('see_apartment')
						: availability === SOLD
						? null
						: t('see_apartment');

					apartmentPath.setAttribute('data-rooms', apartmentData.rooms);

					apartmentTooltipContent = {
						title: title,
						surface,
						rooms,
						tier: tierText,
						availability,
						btntext: btnText,
						id: apartmentIdFromPath,
						behavior: 1,
					};

					filteredApartmentTooltipContent = {
						// TODO: if scrollTo filter settings is implemented, inform user that scroll/open will happen
						title: title,
						comment: `${t('unit')} ${t('hidden_by_filter')}`,
					};

					if (activeApartment == apartmentIdFromPath) {
						apartmentPath.classList.add('active');
						if (isMobile) {
							setTooltipContent(
								// { title: title, surface: surface, rooms: rooms, tier: tier, btntext: t('see_apartment'), id: apartmentIdFromPath, behavior: 1, availability: availability }
								apartmentTooltipContent
							);
							setTooltipVisible(true);
						}
					} else {
						apartmentPath.classList.remove('active');
					}

					if (isVisibleAfterFilter) {
						if (apartmentData.availability === SOLD) {
							apartmentPath.classList.add('state-sell');
						} else {
							apartmentPath.classList.add('rooms-color');
						}
					} else {
						apartmentPath.classList.remove('rooms-color');
						apartmentPath.classList.remove('state-sell');
					}

					const filterRoomsExists = newRoomsFilterValues.some(
						(rooms) => rooms == apartmentData.rooms
					);
					if (!filterRoomsExists) {
						newRoomsFilterValues.push(apartmentData.rooms);
					}
				}

				const handleApartmentMouseOver = () => {
					if (isMobile) return;

					if (apartmentData) {
						if (!isVisibleAfterFilter) {
							setTooltipContent(filteredApartmentTooltipContent);
						} else {
							setTooltipContent(apartmentTooltipContent);
						}
					} else {
						setTooltipContent(isInaccessibleTooltipContent);
					}
					setTooltipVisible(true);
				};

				const handleApartmentMouseLeave = () => {
					if (!isMobile) {
						setTooltipVisible(false);
						setTooltipContent(null);
					}
				};

				const handleApartmentClick = () => {
					if (!apartmentData) {
						if (isMobile) {
							setTooltipContent(isInaccessibleTooltipContent);
							setTooltipVisible(true);
							lastClickedMobileElementRef.current = null;
						} else return; // TODO: in future we will handle this case differently, by showing similar apartments;
					}
					if (!isVisibleAfterFilter) {
						if (isMobile) {
							setTooltipContent(filteredApartmentTooltipContent);
							setTooltipVisible(true);
							lastClickedMobileElementRef.current = null;
						} else return; // TODO: possibly scroll to filter settings
					}
					if (apartmentData.availability === SOLD && !areSoldAccessible) {
						return;
					}

					updateUrlHash('apartment');

					if (isDesktop) {
						setTooltipContent(null);
						setTooltipVisible(false);
						setActiveApartmentHandle(apartmentIdFromPath, activeTier);
					} else if (isMobile) {
						if (lastClickedMobileElementRef.current === apartmentPath) {
							setActiveApartmentHandle(apartmentIdFromPath, activeTier);
							lastClickedMobileElementRef.current = null;
						} else {
							setTooltipContent(apartmentTooltipContent);
							setTooltipVisible(true);
							lastClickedMobileElementRef.current = apartmentPath;
						}
					}
				};

				apartmentPath.addEventListener('mouseover', handleApartmentMouseOver);
				listenersRef.current.push({
					element: apartmentPath,
					type: 'mouseover',
					handler: handleApartmentMouseOver,
				});

				apartmentPath.addEventListener('mouseleave', handleApartmentMouseLeave);
				listenersRef.current.push({
					element: apartmentPath,
					type: 'mouseleave',
					handler: handleApartmentMouseLeave,
				});

				apartmentPath.addEventListener('click', handleApartmentClick);
				listenersRef.current.push({
					element: apartmentPath,
					type: 'click',
					handler: handleApartmentClick,
				});

				const handleOutsideMobileClick = (event) => {
					if (!isMobile || !tooltipVisible) return;
					const clickedPath = event.target.closest('path');
					let shouldCloseTooltip = true;
					if (clickedPath) {
						const isHandledInteractivePath = Array.from(apartmentsPaths).some(
							(p) => p === clickedPath
						);
						if (isHandledInteractivePath) shouldCloseTooltip = false;
					}
					if (shouldCloseTooltip) {
						setTooltipVisible(false);
						setTooltipContent(null);
						lastClickedMobileElementRef.current = null;
					}
				};

				const container = document.querySelector('.tier'); // lub inny główny wrapper
				if (container) {
					container.addEventListener('click', handleOutsideMobileClick);
					listenersRef.current.push({
						element: container,
						eventType: 'click',
						handler: handleOutsideMobileClick,
					});
				}
			});

			if (newRoomsFilterValues.length > 0) {
				setRoomFilter(newRoomsFilterValues);
			} else {
				setRoomFilter([]);
			}
		}
	}

	const zoomHandle = (direction) => {
		if (Viewer) {
			if (direction > 0) {
				Viewer.current.zoomIn();
			} else {
				Viewer.current.zoomOut();
			}
		}
	};

	async function fetchTiersCss(edifice) {
		try {
			const response = await fetch(
				/* webpackMode: "eager" */
				`${dataUrl}tiers/tier.css`
			);
			if (response.ok) {
				const text = await response.text();
				return text;
			}
		} catch (error) {}
	}

	const decodeSvg = (arrayBuffer) => {
		let svgText;

		// Detect encoding
		const utf16LEBOM = new Uint8Array([0xff, 0xfe]);
		const utf16BOM = new Uint8Array(arrayBuffer.slice(0, 2));

		if (utf16BOM[0] === utf16LEBOM[0] && utf16BOM[1] === utf16LEBOM[1]) {
			// UTF-16 LE
			const decoder = new TextDecoder('utf-16le');
			svgText = decoder.decode(arrayBuffer);
		} else {
			// Default to UTF-8
			const decoder = new TextDecoder('utf-8');
			svgText = decoder.decode(arrayBuffer);
		}

		return svgText;
	};

	async function fetchTierLayers(edificesCadIds, tiersData) {
		const newTierLayer = [];
		for (const [edificeIndex, edifice] of edificesCadIds.entries()) {
			const newTiers = tiersData.filter((tier) => tier.edifice_id == edifice);
			for (const [tierIndex, tier] of newTiers.entries()) {
				// const svgName = `${tierIndex}.svg`;
				const svgName = `${edifice}-00-${tierIndex
					.toString()
					.padStart(2, '0')}.svg`;
				try {
					// const cssText = await fetchTiersCss(edifice);
					const cssText = ''; // TODO: currently packager does not put css file for tiers, so we skip it for now
					const response = await fetch(
						/* webpackMode: "eager" */
						// `${dataUrl}edifices/${edifice}/tiers/${svgName}`
						`${dataUrl}/tiers/${svgName}`
					);
					if (response.ok) {
						const arrayBuffer = await response.arrayBuffer();
						const svgText = decodeSvg(arrayBuffer);
						const parser = new DOMParser();
						const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
						const svgElement = svgDoc.querySelector('svg');

						const modifySvgElement = (svgElement) => {
							if (!svgElement) return;
							appendSvgHeightWidth(svgElement);
							appendSvgStyle(svgElement, cssText);
							svgElement.setAttribute('class', 'tier');
							return svgElement;
						};

						const modifiedSvgElement = modifySvgElement(svgElement);

						/*
            const text = await response.text();
            const modifiedText = text
              .replace(/<style[\s\S]*?<\/style>/gi, '') // Usuń wszystkie tagi <style>
              .replace(
                /<svg[^>]*>([\s\S]*?)<\/svg>/i, // Dopasuj <svg> oraz jego zawartość
                (match, content) => {
                  const styleTag = `<style>${cssText}</style>`;
                  return styleTag + content; // Zwróć style oraz zawartość SVG
                }
              );

            newTierLayer.push(modifiedText);
            */
						newTierLayer.push(modifiedSvgElement.outerHTML);
					} else {
						console.error(`Błąd pobierania pliku SVG: ${svgName}`);
					}
				} catch (error) {
					console.error(`Błąd podczas pobierania ${svgName}:`, error);
				}
			}
		}
		setTiersLayers(newTierLayer);
	}

  	const getFontSize = () => {
		if (window.innerWidth <= 992) return 12;
		if (window.innerWidth <= 1366) return 14;
		return 16;
	};

	function changeTierHandle(direction) {
		const edificeTiersData = tiersData.filter(
			(tier) =>
				tier.edifice == (activeBuilding || buildingsData[0].name_original)
		);
		if (direction == 'next') {
			let activeTierFromState = activeTier;
			let newTier = activeTierFromState;
			if (++newTier > edificeTiersData.length - 1) {
				newTier = edificeTiersData.length - 1;
			} else {
				setActiveTier(newTier);
				setTooltipVisible(false);
			}
		} else {
			let activeTierFromState = activeTier;
			let newTier = --activeTierFromState;
			if (newTier < 0) {
				newTier = 0;
			}
			setActiveTier(newTier);
			setTooltipVisible(false);
		}
	}

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
			// isDesktop && tiersViewRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		} else {
			// tiersViewRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, [activeTier, activeApartment]);

	useEffect(() => {
		if (activeBuilding && buildingsData && buildingsData.length > 1) {
			const activeBuildingId = buildingsData.find(
				(edifice) => edifice.name_original === activeBuilding
			)?.id_cad;
			fetchTierLayers([activeBuildingId], tiersData);
		} else {
			if (buildingsData && buildingsData.length == 1) {
				fetchTierLayers([buildingsData[0].id_cad], tiersData);
			} else {
				const multiEdifces = [];
				buildingsData.forEach((edifice) => {
					multiEdifces.push(edifice.id_cad);
				});
				fetchTierLayers(multiEdifces, tiersData);
			}
		}
	}, [loading, buildingsData, activeBuilding]);

	useEffect(() => {
		if (!buildingsData || buildingsData.length === 0) return;
		let edifice = {};
		if (!activeBuilding) {
			edifice = buildingsData[0];
		} else {
			edifice = buildingsData.find(
				(edifice) => edifice.name_original == activeBuilding
			);
		}
		const compassRotationDeg = getRotateToNorthAngleDeg(edifice?.azimuth || 0);
		setCompassAzimuth(compassRotationDeg);
	}, [activeBuilding, buildingsData]);

	useEffect(() => {
		if (tiersLayers && tiersLayers.length > 1) {
			setActiveTierLayerSvg(tiersLayers[activeTier]);
		}
	}, [tiersLayers, activeTier]);

	useEffect(() => {
		if (activeTierLayerSvg) {
			setLayerListener();
		}
	}, [activeTierLayerSvg, activeApartment]);

	// Scroll tier list when activeTier changes
	useEffect(() => {
		if (activeTier !== null && tiersScrollContainerRef.current) {
			scrollTierIntoView(activeTier);
		}
	}, [activeTier]);

	// Cleanup scroll interval on unmount
	useEffect(() => {
		return () => {
			if (scrollIntervalRef.current) {
				clearInterval(scrollIntervalRef.current);
			}
		};
	}, []);

	const buildingsTiers = activeBuilding
		? tiersData.filter((tier) => tier.edifice === activeBuilding)
		: tiersData.filter(
				(tier) => tier.edifice === buildingsData[0].name_original
		  );

	if (loading || componentLoading || !projectData) {
		return <Loading />;
	}

	return (
		<div id="tiers" className={styles.tiers_view} ref={tiersViewRef}>
			{isDesktop && (
				<div className={styles.top_bar}>
					<h2>{t('select_apartment')}</h2>
					{buildingsData.length > 1 && (
						<div
							style={{
								display: 'flex',
								gap: '1rem',
								lineHeight: '2rem',
								alignItems: 'center',
								justifyContent: 'center',
								marginRight: '6rem',
								fontSize: '1rem',
							}}
						>
							<span>{t('building')}:</span>
							<ToggleButtonsGroup
								children={buildingsData.map((building, index) => {
									return (
										<button
											className={`${buttons_styles['bim_button']} ${
												(activeBuilding == null && index == 0) ||
												building.name_original == activeBuilding
													? buttons_styles['bim_button--selected']
													: ''
											}`}
											key={`building${index}`}
											onClick={() => setActiveBuilding(building.name_original)}
										>
											{building.name_original}
										</button>
									);
								})}
							/>
						</div>
					)}
					{isDesktop && <ComponentCloseButton flag="tier" />}
				</div>
			)}
			<div className={styles.view_container}>
				<div className="tier_compass">
					<IconCompass
						style={{
							transform: `rotate(${-compassAzimuth}deg)`,
						}}
						alt="Compass"
					/>
				</div>
				<div className={styles.view}>
					{activeTierLayerSvg && (
						<TransformWrapper
							initialScale={1}
							minScale={0.9}
							maxScale={5}
							ref={Viewer}
							wheel={{ disabled: true }}
							initialPositionX={0.5}
							initialPositionY={0.5}
						>
							<TransformComponent>
								{/* <div style={{ width: '100%', height: '100%' }}> */}
								<TierSvgLayer
									key={`svg_tier${activeTier}`}
									svgLayer={activeTierLayerSvg}
								/>
								{/* </div> */}
							</TransformComponent>
						</TransformWrapper>
					)}
					{roomFilter && (
						<div className={styles.filter_bar} key={`${activeTier}`}>
							{roomFilter
								.sort((a, b) => a - b)
								.map((filter, index) => {
									return (
										<button
											data-rooms={`${filter}`}
											className={`${styles.rooms_filter_btn} `}
											// onClick={() => { toggleRoomFilter(filter) }} //TODO: fix this to toggle room filter
											onClick={() =>
												applyFiltersHandler({ ['rooms']: [filter, filter] })
											}
											key={`room_filter_${index}`}
										>
											<div
												data-rooms={`${filter}`}
												style={{
													backgroundColor: `#${
														projectStyle.roomsColors[filter]
													}60`,
												}}
												className={styles.styles_rooms_indicator}
											></div>
											{`${t('rooms')}: ${filter}`}
										</button>
									);
								})}
							<div
								className={`${styles.rooms_filter_btn} `}
							>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width={`${getFontSize() * 1.2}px`} 
                  height={`${getFontSize() * 1.2}px`} 
                  viewBox={`0 0 ${getFontSize() * 1.2} ${getFontSize() * 1.2}`} 
                >
                  <rect 
                    width={`${getFontSize() * 1.2}px`} 
                    height={`${getFontSize() * 1.2}px`} 
                    className={styles.active_apartment_legend}
                  />
                </svg>
								{t('opened_apartment')}
							</div>
						</div>
					)}
					{!isMobile && (
						<div className={styles.tiers_zoom}>
							<div>
								<button
									className={buttons_styles['bim_button']}
									onClick={() => {
										zoomHandle(0.1);
									}}
								>
									<IconPlus className={buttons_styles['bim_button__icon']} />
								</button>
								<button
									className={buttons_styles['bim_button']}
									onClick={() => {
										zoomHandle(-0.1);
									}}
								>
									<IconMinus className={buttons_styles['bim_button__icon']} />
								</button>
							</div>
							<div>
								<span>{t('scale')}</span>
							</div>
						</div>
					)}
					{isMobile && (
						<div className={styles.tiers_nav_bar}>
							<div className={styles.tiers_nav}>
								<div>
									<button
										onClick={() => {
											changeTierHandle('prev');
										}}
									>
										<img
											src={`${
												window.bimWebloData
													? window.bimWebloData.pageUrl
													: window.location.origin
											}${DownArrowIcon}`}
											alt=""
										/>
									</button>
									<button
										onClick={() => {
											changeTierHandle('next');
										}}
									>
										<img
											src={`${
												window.bimWebloData
													? window.bimWebloData.pageUrl
													: window.location.origin
											}${UpArrowIcon}`}
											alt=""
										/>
									</button>
								</div>
								<div>
									<span>{t('tier')}</span>
								</div>
							</div>
							<div className={styles.tiers_info}>
								<div>
									<p>
										{t('tier')} - {activeTier}
									</p>
								</div>
								<span>
									{t('building')} -{' '}
									{activeBuilding || buildingsData[0].name_original}
								</span>
							</div>
							<div className={styles.tiers_zoom}>
								<div>
									<button
										onClick={() => {
											zoomHandle(0.1);
										}}
									>
										<img
											src={`${
												window.bimWebloData
													? window.bimWebloData.pageUrl
													: window.location.origin
											}${PlusIcon}`}
											alt=""
										/>
									</button>
									<button
										onClick={() => {
											zoomHandle(-0.1);
										}}
									>
										<img
											src={`${
												window.bimWebloData
													? window.bimWebloData.pageUrl
													: window.location.origin
											}${MinusIcon}`}
											alt=""
										/>
									</button>
								</div>
								<div>
									<span>{t('scale')}</span>
								</div>
							</div>
						</div>
					)}
				</div>
				{isDesktop && (
					<div className={styles.tiers}>
						<div className={styles.select_tier}>
							<span style={{ marginBottom: '16px' }}>{t('tier')}:</span>
							{tiersLayers && (
								<div className={styles.tiers_scroll_wrapper}>
									{buildingsTiers.length > MAX_VISIBLE_TIERS && (
										<button
											className={buttons_styles['bim_button']}
											onMouseDown={() => handleChevronMouseDown('up')}
											onMouseUp={handleChevronMouseUp}
											onMouseLeave={handleChevronMouseUp}
											onTouchStart={() => handleChevronMouseDown('up')}
											onTouchEnd={handleChevronMouseUp}
											onClick={(e) => e.preventDefault()}
										>
											<IconChevron
												className={buttons_styles['bim_button__icon']}
												style={{ transform: 'rotate(-90deg)' }}
											/>
										</button>
									)}
									<div
										className={styles.tiers_scroll_container}
										ref={tiersScrollContainerRef}
										style={{
											maxHeight:
												buildingsTiers.length > MAX_VISIBLE_TIERS
													? `calc(${MAX_VISIBLE_TIERS} * ${TIER_BUTTON_HEIGHT})`
													: 'none',
										}}
									>
										<ToggleButtonsGroup vertical={true}>
											<>
												{buildingsTiers
													.map((tier, index) => {
														return (
															<button
																className={`${buttons_styles['bim_button']} ${
																	(activeTier == null && index == 0) ||
																	tier.ref_tier == activeTier
																		? buttons_styles['bim_button--selected']
																		: ''
																}`}
																key={`tier${index}`}
																onClick={() => {
																	setActiveTierIndex(index);
																	setActiveTier(index);
																}}
															>
																{tier.ref_tier}
															</button>
														);
													})
													.reverse()}
											</>
										</ToggleButtonsGroup>
									</div>
									{buildingsTiers.length > MAX_VISIBLE_TIERS && (
										<button
											className={buttons_styles['bim_button']}
											onMouseDown={() => handleChevronMouseDown('down')}
											onMouseUp={handleChevronMouseUp}
											onMouseLeave={handleChevronMouseUp}
											onTouchStart={() => handleChevronMouseDown('down')}
											onTouchEnd={handleChevronMouseUp}
											onClick={(e) => e.preventDefault()}
										>
											<IconChevron
												className={buttons_styles['bim_button__icon']}
												style={{ transform: 'rotate(90deg)' }}
											/>
										</button>
									)}
								</div>
							)}
						</div>
					</div>
				)}
			</div>
			{tooltipVisible && (
				<ToolTip
					content={tooltipContent}
					setTooltipVisible={setTooltipVisible}
				/>
			)}
		</div>
	);
}
export default TiersView;
